import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const session_id = decodeURIComponent(match[1]);
        (async () => {
            try {
                await api.post("/auth/google/session", { session_id });
                window.history.replaceState({}, "", "/dashboard");
                await refresh();
                navigate("/dashboard", { replace: true });
            } catch {
                navigate("/login?error=google", { replace: true });
            }
        })();
    }, [location.hash, navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
            <div className="text-center">
                <div className="w-8 h-8 border-2 border-slate-200 border-t-[#C55A46] rounded-full animate-spin mx-auto mb-4" />
                <p className="text-slate-600 text-sm">Signing you in…</p>
            </div>
        </div>
    );
}
